import React, { useState, useEffect } from 'react';
import { Button, Modal, Form, Input, Select } from 'antd';
import { FetchVariable } from '../../../Components/FetchVariable/FetchVariable';
import axios from 'axios';
const { Option } = Select;


const ModelAddForm = ({ visible, onCreate, onCancel }) => {

    const [form] = Form.useForm();
    const [make, setMake]=useState()

    useEffect(()=>{
        //${FetchVariable.Heroku}
        let getMake = `${FetchVariable.Heroku}/make/`
            axios.get(getMake)
            .then((res)=>{
              let data = res.data
              setMake(data)
          })

    },[])

  return (
    <Modal
      visible={visible}
      title="Create a new collection"
      okText="Create"
      cancelText="Cancel"
      onCancel={onCancel}
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            form.resetFields();
            onCreate(values);
          })
          .catch((info) => {
            console.log('Validate Failed:', info);
          });
      }}

    >
      <Form
        form={form}
        layout="vertical"
        name="ModelForm"
        initialValues={{
          MakeID:'',
          Model:''
      }}
      >
        {/* <Form.Item
          name="MakeName"
          label="Make Name"
        >
          <Input />
        </Form.Item> */}
        <Form.Item name='MakeID' label="Make">
          <Select
            showSearch
            placeholder="Select Vehicle Make"
            optionFilterProp="children"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
          {make?.map(Make=><Option value={Make.MakeID} key={Make.MakeID}>{Make.Make}</Option>)}
          </Select>

        </Form.Item>
        <Form.Item name="Model" label="Enter Vehicle model">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};

const ModelAdd = (props) => {
  const [visible, setVisible] = useState(false);

  const onCreate = (values) => {
    props.addModel(values)
    setVisible(false);
  };

  return (
    <div>
      <Button
        type="primary"
        onClick={() => {
          setVisible(true);
        }}
        
      >
        Add New Car Model
      </Button>
      <ModelAddForm
        visible={visible}
        onCreate={onCreate}
        onCancel={() => {
          setVisible(false);
        }}
      />
    </div>
  );
};

export default ModelAdd